export default __webpack_public_path__ + "static/media/19.30b78437.jpg";